import posthog from 'posthog-js';

export const trackPostHog = (eventName, properties = {}) => {
  // Only send events in production
  if (import.meta.env.VITE_PUBLIC_APP_ENV !== 'production') {
    console.log('PostHog Event (dev):', eventName, properties);
    return;
  }

  if (typeof window !== 'undefined' && posthog) {
    posthog.capture(eventName, properties);
  }
};

// Example: Track user sign-in
export const trackSignIn = (method) => {
  const eventData = {
    auth_method: method,
    timestamp: new Date().toISOString()
  };

  trackPostHog('user_signed_in', eventData);
};

// Track user sign-out
export const trackSignOut = () => {
  const eventData = {
    timestamp: new Date().toISOString()
  };

  trackPostHog('user_signed_out', eventData);
};

// Track page views
export const trackPageView = (pageName, properties = {}) => {
  const eventData = {
    page_name: pageName,
    timestamp: new Date().toISOString(),
    ...properties
  };

  trackPostHog('$pageview', eventData);
};

// Track repository actions
export const trackRepositoryAction = (action, repositoryData = {}) => {
  const eventData = {
    action,
    timestamp: new Date().toISOString(),
    ...repositoryData
  };

  trackPostHog('repository_action', eventData);
};

// Track conversation actions
export const trackConversationAction = (action, conversationData = {}) => {
  const eventData = {
    action,
    timestamp: new Date().toISOString(),
    ...conversationData
  };

  trackPostHog('conversation_action', eventData);
}; 